import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";

import { AppComponent } from "./app.component";
import { LanguageService } from "./core/services/languages-service/languajes.service";
import { TranslateLoader, TranslateModule, TranslateService } from "@ngx-translate/core";
import { SharedModuleModule } from "./shared/sharedModule.module";
import { AppRoutingModule } from "./app-routing.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { FormsModule } from "@angular/forms";
import { LocalStorageService } from "src/services/local-storage.service";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { NumericOnlyDirective } from './helpers/numeric-only.directive';
import { AcknowledgmentsModalComponent } from './shared/acknowledgments-modal/acknowledgments-modal.component';
import { devicenotrecommendedModalComponent } from './shared/devicenotrecommended-modal/devicenotrecommended-modal.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    NumericOnlyDirective,
    AcknowledgmentsModalComponent,
    devicenotrecommendedModalComponent,
  ],
  imports: [
    BrowserModule,
    SharedModuleModule,
    AppRoutingModule,
    FormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    BrowserAnimationsModule,
    NgbModule,
    HttpClientModule,
    InfiniteScrollModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(
    private language: LanguageService,
    private translate: TranslateService
  ) {
    this.language.getStartupLanguage().subscribe((res: string) => {
      this.translate.use(res);
    });
  }
}
